import { FuelDivider, FuelSkeleton } from '@frete.com/fuel-react';
import { FuelFlex, FuelSpacer } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import React from 'react';
import { TSkeletonListItemProps } from './types';

export const SkeletonListItem: React.FC<TSkeletonListItemProps> = ({ showDivider = true }) => (
  <>
    <FuelFlex
      testId="skeleton-list-item"
      defaultProps={{
        gap: 'km5',
        customPadding: `${dsTheme.spacing.km6} ${dsTheme.spacing.km4}`,
        alignItems: 'center',
      }}
      smProps={{ flexDirection: 'column', gap: 'km4' }}
    >
      <FuelFlex
        defaultProps={{ alignItems: 'center', height: '100%' }}
        mdProps={{ alignItems: 'flex-start' }}
        smProps={{ width: '100%' }}
      >
        <FuelSkeleton size="custom" shape="square" height="20px" width="20px" />
      </FuelFlex>
      <FuelFlex
        defaultProps={{ flexDirection: 'row', flexGrow: 5, gap: 'km2', alignItems: 'center' }}
        smProps={{ width: '100%' }}
      >
        <FuelSkeleton size="custom" shape="circle" height="48px" width="48px" />
        <FuelFlex defaultProps={{ flexDirection: 'column', width: 'calc(100% - 48px - 8px)', gap: 'km2' }}>
          <FuelSkeleton size="custom" shape="square" height="16px" width="85%" />
          <FuelSkeleton size="custom" shape="square" height="12px" width="60%" />
          <FuelSkeleton size="custom" shape="square" height="12px" width="60%" />
        </FuelFlex>
      </FuelFlex>
      <FuelFlex defaultProps={{ flexGrow: 4, gap: 'km2' }} smProps={{ width: '100%' }}>
        <FuelFlex
          defaultProps={{ flexDirection: 'column', gap: 'km2', width: '100%' }}
          smProps={{ display: 'none' }}
          mdProps={{ display: 'none' }}
        >
          <FuelSkeleton size="custom" shape="square" height="14px" width="85%" />
          <FuelSkeleton size="custom" shape="square" height="14px" width="85%" />
        </FuelFlex>

        <FuelFlex
          defaultProps={{ display: 'none' }}
          smProps={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center' }}
          mdProps={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center' }}
        >
          <FuelSkeleton size="custom" shape="square" height="14px" width="85%" />
          <FuelSpacer orientation="vertical" y="km1" />
          <FuelSkeleton size="custom" shape="square" height="10px" width="85%" />
          <FuelSpacer orientation="vertical" y="km4" />
          <FuelSkeleton size="custom" shape="square" height="14px" width="85%" />
        </FuelFlex>
      </FuelFlex>
      <FuelFlex defaultProps={{ flexGrow: 2 }} smProps={{ display: 'none' }} mdProps={{ display: 'none' }}>
        <FuelSkeleton size="custom" shape="square" height="14px" width="100%" />
      </FuelFlex>
    </FuelFlex>
    {showDivider && <FuelDivider size="default" />}
  </>
);
